import { type UseQueryResult, useQuery } from 'react-query';
import { PerformanceRuleService } from '../../services/wealthlane-award-services';

const useGetPerformanceRuleEarnedStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const performanceRuleEarnedStatus = useQuery(
    ['getPerformanceRuleEarnedStatus'],
    async () => {
      return await handleRequest(
        PerformanceRuleService.getApiAwardApiAppPerformanceRuleRuleEarnedlStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return performanceRuleEarnedStatus;
};

export default useGetPerformanceRuleEarnedStatus;
